export const PAGINATION_LIMITS = [10, 20, 50, 100, 150, 200, 250]
export const PAGINATION_LIMIT = 100
export const INITIAL_PAGE = 0
